module.exports = __webpack_public_path__ + "img/logo-diseno-grafico.fb4bfe4f.png";